const activeClassName = 'season-table__active';
const navigatorClassName = 'season-table__navigator';
const indexSelector = '.season-table__entry--';
const now = (() => {
    const date = new Date();
    const year = date.getFullYear().toString();
    let month = date.getMonth() + 1;
    if (month < 10) {
        month = `0${month}`;
    }
    let day = date.getDate().toString();
    if (day < 10) {
        day = `0${day}`;
    }
    return parseInt(`${year}${month}${day}`);
})();

function setActive(table, currentIndex) {
    [...table.querySelectorAll(`.${activeClassName}`)].forEach(node => {
        node.classList.remove(activeClassName);
    });
    [...table.querySelectorAll(`${indexSelector}${currentIndex}`)].forEach(node => {
        node.classList.add(activeClassName);
    });
}

function buttonType(button) {
    return button.classList.contains(`${navigatorClassName}--prev`) ? -1 : 1;
}

function handleButtons(currentButton, allButtons, currentIndex, maxIndex) {
    // Enable all other buttons
    allButtons.forEach(button => {
        if (button != currentButton) {
            button.disabled = false;
        }
    });

    if (buttonType(currentButton) > 0) {
        // It is the next button
        currentButton.disabled = currentIndex === maxIndex;
    } else {
        // It is the prev button
        currentButton.disabled = currentIndex === 0;
    }
}
[...document.querySelectorAll('.season-table')].forEach(table => {
    const dateNodes = [...table.querySelectorAll('.season-table__dates')];
    const buttons = [...table.querySelectorAll(`.${navigatorClassName}`)];
    let currentIndex = false;
    let maxIndex = false;
    dateNodes.forEach(dateNode => {
        const dataset = dateNode.dataset;
        const start = parseInt(dataset.start);
        const end = parseInt(dataset.end);
        let index = parseInt(dataset.index);
        maxIndex = index;
        console.log(now, start, end, start <= now, end >= now, start <= now && end >= now)

        if (start <= now && end >= now) {
            currentIndex = index;
            setActive(table, index);
        }
    });

    if (currentIndex === false || maxIndex === false || !buttons.length) {
        // Stop if we have no index
        return;
    }

    buttons.forEach(button => {
        button.classList.remove(`${navigatorClassName}--hidden`);
        handleButtons(button, [], currentIndex, maxIndex);
        button.addEventListener('click', () => {
            currentIndex = currentIndex + buttonType(button);
            handleButtons(button, buttons, currentIndex, maxIndex);
            setActive(table, currentIndex);
        });
    });
});
